import { render, staticRenderFns } from "./ContactSupportMould.vue?vue&type=template&id=b4376aaa&scoped=true"
import script from "./ContactSupportMould.vue?vue&type=script&lang=js"
export * from "./ContactSupportMould.vue?vue&type=script&lang=js"
import style0 from "./ContactSupportMould.vue?vue&type=style&index=0&id=b4376aaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4376aaa",
  null
  
)

export default component.exports